module.exports = __webpack_public_path__ + "static/media/recaptch-img.556b6b81.svg";